import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=14b5d4c4&scoped=true"
import script from "./Policy.vue?vue&type=script&lang=js"
export * from "./Policy.vue?vue&type=script&lang=js"
import style0 from "./Policy.vue?vue&type=style&index=0&id=14b5d4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b5d4c4",
  null
  
)

export default component.exports